module.exports = __webpack_public_path__ + "img/icon-marker-green.92cfd693.svg";